import React, { useLayoutEffect, useRef } from 'react';
import Container from './Container';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const AboutLocation = () => {
  const mapsUrl = 'https://maps.app.goo.gl/uHGQyXcYwtnpWkkv8';
  const containerRef = useRef(null);
  const cardRef = useRef(null);

  const openMaps = () => {
    window.open(mapsUrl, '_blank', 'noopener');
  };

  const onKeyActivate = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      openMaps();
    }
  };

  useLayoutEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    const ctx = gsap.context(() => {
      if (!cardRef.current) return;
      gsap.fromTo(cardRef.current,
        { opacity: 0, y: 20, scale: 0.96 },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.6,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: containerRef.current,
            start: 'top 80%',
            toggleActions: 'play none none none',
            once: true
          }
        }
      );
    }, containerRef);
    return () => ctx.revert();
  }, []);

  return (
    <section className="about-location section" ref={containerRef}>
      <div className="section-bg" aria-hidden="true">
        <img src="/images/our_location.webp" alt="" loading="lazy" decoding="async" />
      </div>
      <Container>
        <div className="location-content">
          <div className="location-header">
            <div className="section-badge">
              <span className="badge-dot"></span>
              <span> Location</span>
            </div>
            <h2>Our Location</h2>
          </div>
          <div className="location-map-container">
            <div className="world-map" onClick={openMaps} onKeyDown={onKeyActivate} role="link" tabIndex={0}>
              <img src="/images/our_location_map.webp" alt="World map" loading="lazy" decoding="async" />
            </div>
            <div
              ref={cardRef}
              className="location-info-card p-4 md:p-6 rounded-lg"
              onClick={openMaps}
              onKeyDown={onKeyActivate}
              role="link"
              tabIndex={0}
              style={{ display: 'flex', flexDirection: 'column', gap: 12 }}
            >
              {/* Top row: image left, heading + first paragraph right */}
              <div className="location-top w-full flex flex-col md:flex-row md:items-center gap-3 md:gap-4 justify-between">
                <div className="location-image flex-shrink-0 mx-auto md:mx-0">
                  <img src="/images/trust_truck.webp" alt="Pune Office" className="w-24 h-24 md:w-28 md:h-28 object-cover rounded-md" loading="lazy" decoding="async" />
                </div>
                <div className="location-top-copy flex flex-col gap-1 md:gap-2 md:flex-1 md:pl-2">
                  <h3 className='!text-2xl md:!text-3xl font-bold'>Pune, India</h3>
                  <p className="location-role text-sm md:text-base max-w-[90%] md:max-w-none !text-black">Corporate Office & Operations Hub</p>
                </div>
              </div>
              {/* Bottom: second paragraph */}
              <div className="location-bottom mt-2 md:mt-3">
                <p className="location-description text-sm md:text-base leading-relaxed">Located in Pune's logistics hub, our headquarters oversees nationwide Air, Rail, and Surface operations, ensuring seamless, tech-driven delivery across India.</p>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default AboutLocation;